import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { useFindJobState } from "../../../data/status";
import { useLookupCode } from "../../../data/lookup";
import Tooltip from "../../custom-ui/tooltip/tooltip";
import { TailwindHoverEnlarge } from "../../../util/tailwind/tailwind-styles";
import DisplayItemLookup from "../../custom-ui/display/displayItemLookups";
import EmojiFlagText from "../../custom-ui/emoji/EmojiFlagText";

const JobNewListingLineComponent = forwardRef(
  ({ row }: { row: any }, ref: any) => {
    const { data: solution } = useLookupCode(row?.hit?.solutionType);
    const { data: statusData } = useFindJobState(row?.hit?.jobState);


    function getExpirationMessage(timestamp: number | null):any {
      if (!timestamp || typeof timestamp !== 'number') return null;

      const now = Date.now(); // current UTC time in milliseconds
      if (timestamp < now) return null;
      const diffTime = timestamp - now;

      const date = new Date(timestamp);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = date.getFullYear();

      const expireDate = ` ${month}/${day}/${year}`;



      // Ignore expired timestamps or those more than 7 days away
      if (diffTime <= 0 || diffTime > 7 * 24 * 60 * 60 * 1000) return expireDate?expireDate:null;

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
   
      return diffDays ;
    }

    const expireDate = getExpirationMessage(row?.hit?.expirationDate)


    //tailwindcss.com/docs/content-configuration#dynamic-class-names
    // Always map props to static class names
    const colorJobListingVariants: any = {
      draft: "bg-instant-teams-tags-CREAM text-black",
      live: "bg-instant-teams-tags-GREEN",
      on_hold: "bg-instant-teams-tags-ROSE",
      closed_filled: "bg-instant-teams-tags-LBLUE",
      closed_cancelled: "bg-instant-teams-gray-D1",
    };

    return (
      <Link
        to={`/jobs-new/${row?.hit?.objectID}/${row?.hit?.companyId}/information`}
        className="cursor-pointer bg-white h-full"
      >
        <div
          ref={ref}
          className={
            TailwindHoverEnlarge(105) +
            "items-center w-full rounded-lg relative shadow-lg pb-2"
          }
        >
          <div className="items-center bg-instant-teams-teal-Main p-5 rounded-t-lg w-full min-h-max h-42">
          <div className="flex items-center justify-between  ">
              <div className="flex">
              <div className={` bg-white text-center  items-center  " pr-10 "   ml-[-20px]`}>
                <p className=" pl-2 py-[1px] items-center text-[10px]">{solution?.[0]?.label || "Not Set"}</p>
              </div>
              <div className=" bg-instant-teams-teal-Main  ml-[-11px] h-5 w-5 rotate-45 ">

              </div>
              </div>
             

              {expireDate && <div className="flex">
                 <div className=" bg-instant-teams-teal-Main  mr-[-7px] h-5 w-5 rotate-45 ">
              </div>
              <div className=" bg-white items-center w-auto pl-3  mr-[-20px]">
                {expireDate && <p className=" pl-[3px] items-center pr-[2px] py-[1px] text-[10px]">{ !isNaN(expireDate)?`Exp. in ${expireDate}  days`: expireDate?`Exp. in ${expireDate}`:''}</p>}
              </div> 
              </div>}
    
            

            </div>
            <div className={`m-auto   w-16 h-16 rounded-full bg-white }`}>
                <img
                  className="object-scale-down w-16 h-16 rounded-full  resize  mt-1 my-auto"
                  src={row?.hit?.companyLogo || "/images/default-employer.jpg"}
                  alt={row?.companyFullName}
                />
              </div>

            <div className="w-full text-white pl-2 mt-1 text-center mb-2">
              <p className={`${expireDate ? "ml-[-8px] " : ""} text-sm`}>{row?.hit?.companyFullName}</p>
              <p className=" text-xl whitespace-nowrap text-ellipsis overflow-hidden">
                <EmojiFlagText>{row?.hit?.jobName}</EmojiFlagText>
              </p>
              <p className="text-xs font-thin">Number of openings:{" "} <strong>{row?.hit?.openings || 1}</strong></p>
              {/* <p className=" text-sm">{solution?.[0]?.label || "Not Set"}</p> */}
            </div>
            {/* <span className="inline-block px-2 py-1 text-xs font-bold leading-none text-instant-teams-teal-Main bg-white rounded-full absolute top-4 left-4">
              <Tooltip text="Positions Created">
                <p>{row?.hit?.summaryCount?.positions}</p>
              </Tooltip>
            </span> */}
            {/* <span className="inline-block px-2 py-1 text-xs font-bold leading-none text-instant-teams-teal-Main bg-white rounded-full absolute top-4 right-4">
              <Tooltip text="Number of Openings">
                <p>{row?.hit?.openings || 1}</p>
              </Tooltip>
            </span> */}
          </div>
          <Tooltip text={statusData?.description || "Current Status"}>
            <div
              className={`items-center w-[90%]  mt-2 rounded-md text-white mx-auto p-1 ${colorJobListingVariants[statusData?.id] ||
                "bg-instant-teams-purple-Main"
                }`}
            >
              <p className="text-center">{statusData?.label}</p>
            </div>
          </Tooltip>

          <div className="flex mt-2 w-full px-3 text-instant-teams-teal-Main text-sm justify-between  items-center">
            <div className=" rounded-lg px-2 py-1  bg-gray-300">
              <DisplayItemLookup value={row?.hit?.workTerm} group={"workTerm"} />
            </div>
            <div className=" rounded-lg px-2 py-1 bg-gray-300">
              <DisplayItemLookup value={row?.hit?.workType} group={"workType"} />
            </div>
            <div className=" rounded-lg px-2 py-1 bg-gray-300">
              <DisplayItemLookup
                value={row?.hit?.workSettings}
                group={"workSetting"}
              />
            </div>

          </div>



          <div className="text-center text-gray-500 text-sm mt-3">
            Hours Per Week:{" "}
            <strong>


              {row?.hit?.hoursPerWeek ? (
                <>
                  {row?.hit?.hoursPerWeek?.min} - {row?.hit?.hoursPerWeek?.max}
                </>
              ) : (
                <>Not Set</>
              )}
            </strong>
          </div>
          <div className="text-center text-gray-500 text-sm mt-1 mb-2">
            Salary Type:
            <strong>
              {row?.hit?.payRate?.type === "hourly" && <span className="ml-[2px]">Hourly</span>}
              {row?.hit?.payRate?.type === "salary" && <span className="ml-[2px]">Yearly</span>}
              {row?.hit?.payRate?.type === "commission" && (
                <span className="ml-[2px]">Commission</span>
              )}
              {row?.hit?.payRate?.type === "unpaid_internship" && (
                <span className="ml-[2px]">Free Internship</span>
              )}
              {!["hourly", "salary", "commission", "unpaid_internship"].includes(
                row?.hit?.payRate?.type,
              ) && <span className="ml-[2px]">Not Set</span>}
            </strong>
          </div>
          <div className=" flex mt-3  justify-center">
            <hr className="w-[90%] h-[1px] bg-gray-300 "></hr>
          </div>

          <div className=" mt-3 px-6 flex justify-between">
            <div className="flex" >
              <img className="h-6 w-6 " src="/images/eyeicon-view.png" />
              <p className="text-[14px] font-bold text-gray-600">
                {row?.hit?.clicksCounter
                  || 0}
              </p>
            </div>
            <div className="flex" >
              <img className="h-7 w-7 " src="/images/clickicon.png" />
              <p className="text-[14px] font-bold text-gray-600">
                {row?.hit?.applyNowCounter
                  || 0}
              </p>
            </div>
          </div>

        </div>
      </Link>
    );
  },
);

export default JobNewListingLineComponent;
